"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployMastercopyWithInitData = exports.deployMastercopy = void 0;
const singletonFactory_1 = require("./singletonFactory");
/**
 * Deploy a module's mastercopy via the singleton factory.
 *
 * To get the same address on any chain.
 * @param hre hardhat runtime environment
 * @param mastercopyContractFactory
 * @param args
 * @returns The address of the deployed module mastercopy
 */
const deployMastercopy = async (hre, mastercopyContractFactory, args, salt) => {
    const deploymentTx = mastercopyContractFactory.getDeployTransaction(...args);
    if (deploymentTx.data) {
        await (0, exports.deployMastercopyWithInitData)(hre, deploymentTx.data, salt);
    }
};
exports.deployMastercopy = deployMastercopy;
const deployMastercopyWithInitData = async (hre, initCode, salt) => {
    const singletonFactory = await (0, singletonFactory_1.getSingletonFactory)(hre);
    const targetAddress = await singletonFactory.callStatic.deploy(initCode, salt);
    const initCodeHash = await hre.ethers.utils.solidityKeccak256(["bytes"], [initCode]);
    const computedTargetAddress = await hre.ethers.utils.getCreate2Address(singletonFactory.address, salt, initCodeHash);
    if (targetAddress == "0x0000000000000000000000000000000000000000") {
        console.log(`        ✔ Mastercopy already deployed to: ${computedTargetAddress}`);
        return;
    }
    let deployData;
    switch (hre.network.name) {
        case "optimism":
            deployData = await singletonFactory.deploy(initCode, salt, {
                gasLimit: 6000000,
            });
            break;
        case "arbitrum":
            deployData = await singletonFactory.deploy(initCode, salt, {
                gasLimit: 200000000,
            });
            break;
        case "avalanche":
            deployData = await singletonFactory.deploy(initCode, salt, {
                gasLimit: 8000000,
            });
            break;
        case "mumbai":
            deployData = await singletonFactory.deploy(initCode, salt, {
                gasLimit: 8000000,
            });
            break;
        default:
            deployData = await singletonFactory.deploy(initCode, salt, {
                gasLimit: 10000000,
            });
            break;
    }
    await deployData.wait();
    if ((await hre.ethers.provider.getCode(targetAddress)).length > 2) {
        console.log(`        \x1B[32m✔ Mastercopy deployed to:\x1B[0m         ${targetAddress}`);
    }
    else {
        console.log("        \x1B[31m✘ Deployment failed.\x1B[0m");
    }
    return targetAddress;
};
exports.deployMastercopyWithInitData = deployMastercopyWithInitData;
